// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__U1yGZ","filesListContainer":"PosDisputesFiles_filesListContainer__32TpM","filesButton":"PosDisputesFiles_filesButton__TzOFK"};